export default __webpack_public_path__ + "static/media/badges_original.5318dc26.jpg";